import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
const ATTENTION_REASONS = {
    value_repeated_in_file: 'value_repeated_in_file',
    value_in_use_on_other_client: 'value_in_use_on_other_record',
    value_replaced_on_client: 'value_replaced_on_record'
};
const attentionFromDTO = (_0)=>{
    let { reason } = _0, attention = _object_without_properties(_0, [
        "reason"
    ]);
    return _object_spread_props(_object_spread({}, attention), {
        reason: ATTENTION_REASONS[reason]
    });
};
export const bulkImportClientsResponseFromDTO = (_0)=>{
    let { attentions } = _0, response = _object_without_properties(_0, [
        "attentions"
    ]);
    return _object_spread_props(_object_spread({}, response), {
        attentions: attentions.map(attentionFromDTO)
    });
};
